import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { environment } from '@environments/environment';
import { ToastrService } from 'ngx-toastr';
import { inject } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';
import { SKIP_ERROR_TOAST } from '@core-utils';
import { LandingAuthService } from '@campaign-landing/shared';

export const AppInterceptor: HttpInterceptorFn = (req, next) => {
  const BASE_URL = environment.api;
  const toastrService = inject(ToastrService);
  const authService = inject(LandingAuthService);

  const isExternalRequest = [
    environment.keycloak.oauthServerHost,
    'assets',
  ].some((url) => req.url.includes(url));

  if (isExternalRequest) {
    return next(req);
  }

  const headers: { [name: string]: string } = {};
  if (req.method === 'POST') {
    headers['Idempotency-Key'] = uuidv4();
  }
  if (authService.hasValidToken()) {
    headers['Authorization'] = `Bearer ${authService.accessToken}`;
  }

  const apiReq = req.clone({
    setHeaders: headers,
    url: `${BASE_URL}${req.url}`,
  });

  return next(apiReq).pipe(
    catchError(({ error }: HttpErrorResponse) => {
      const skipErrorToast = req.context.get(SKIP_ERROR_TOAST);
      if (!skipErrorToast) {
        let errorMessage =
          'An unexpected error occurred. Please try again later.';

        let parsedError = error;
        if (typeof error === 'string') {
          parsedError = JSON.parse(error);
        }

        if (parsedError?.detail) {
          errorMessage = parsedError.detail;
        }

        if (parsedError?.errors?.length > 0) {
          errorMessage = parsedError.errors[0].description;
        }

        toastrService.error(errorMessage, 'Error');
      }

      return throwError(() => error);
    }),
  );
};
